import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class UpdateOrderStatus extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Update Order Status</h1>
				<p>This method updates the status of a specific order.</p>
				<h4>Request</h4>
				<table>
					<tbody>
						<tr>
							<th>Method </th>
							<th>URI </th>
						</tr>
						<tr>
							<td> PUT </td>
							<td> {`/orders/{order_id}/status`} </td>
						</tr>
					</tbody>
				</table>
				<h4>Parameters</h4>
				<table>
					<tbody>
						<tr>
							<th>Parameter Name </th>
							<th>Value </th>
							<th>Optional </th>
							<th>Description </th>
						</tr>
						<tr>
							<td> order_id </td>
							<td> Integer </td>
							<td> N</td>
							<td> The ID of the order to update status </td>
						</tr>
					</tbody>
				</table>
				<h4>Request body</h4>
				<p>In the request body, supply a patch object with the following structure:</p>
				<table>
					<tbody>
						<tr>
							<th>Property Name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Notes </th>
						</tr>
						<tr>
							<td> field </td>
							<td> String </td>
							<td> The field name of the resource to be updated </td>
							<td> Must be "status" </td>
						</tr>
						<tr>
							<td> value </td>
							<td> String </td>
							<td> The new status value </td>
							<td> <a href="http://www.bricklink.com/help.asp?helpID=41" target="_blank">Available status</a> </td>
						</tr>
					</tbody>
				</table>
				<Highlight className="json">{`{
    "field" : "status",
    "value" : "PENDING" 
}`}</Highlight>
				<h4>Response</h4>
				<p>If successful, this method returns an empty "data".</p>
				<h4>Example</h4>
				<ul>
					<li>
						PUT /orders/1234/status
						<ul>
							<li>Updates status of order #1234</li>
						</ul>
					</li>
				</ul>
			</section>
		);
	}
}